import backendUrl from "./backendUrl";

export const userApi = {
  allUser: {
    url: `${backendUrl}/api/all-user`,
    method: "get",
  },
  updateUser: {
    url: `${backendUrl}/api/update-user`,
    method: "post",
  },
  addToCartProduct: {
    url: `${backendUrl}/api/addtocart`,
    method: "post",
  },
  addToCartProductCount: {
    url: `${backendUrl}/api/countAddToCartProduct`,
    method: "get",
  },
  addToCartProductView: {
    url: `${backendUrl}/api/view-card-product`,
    method: "get",
  },
  updateCartProduct: {
    url: `${backendUrl}/api/update-cart-product`,
    method: "post",
  },
  deleteCartProduct: {
    url: `${backendUrl}/api/delete-cart-product`,
    method: "post",
  },
  payment: {
    url: `${backendUrl}/api/checkout`,
    method: "post",
  },
  getOrder: {
    url: `${backendUrl}/api/order-list`,
    method: "get",
  },
  allOrder: {
    url: `${backendUrl}/api/all-order`,
    method: "get",
  },
  fetchAuditLogs: {
    url: `${backendUrl}/api/audit/logs`,
    method: "get",
  },
  fetchAuditLogsByUserId: {
    url: `${backendUrl}/api/audit/logs/user/:userId`,
    method: "get",
  },
  fetchAuditLogsByAction: {
    url: `${backendUrl}/api/audit/logs/action/:action`,
    method: "get",
  },
  createAdminOrder: {
    url: `${backendUrl}/api/admin-create-order`,
    method: "post",
  },
};
